module.exports = __webpack_public_path__ + "static/media/axa.8024a2fd.svg";